var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "breadcrumbs" },
    [
      _vm.homeTitle && !_vm.mobile
        ? _c(
            "li",
            { staticClass: "breadcrumbs__item" },
            [
              _c(
                "nuxt-link",
                {
                  staticClass: "breadcrumbs__link",
                  attrs: { to: _vm.homeLink }
                },
                [_vm._v(_vm._s(_vm.homeTitle))]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.crumbs, function(link) {
        return !_vm.mobile
          ? _c(
              "li",
              { staticClass: "breadcrumbs__item" },
              [
                _c(
                  "nuxt-link",
                  {
                    staticClass: "breadcrumbs__link",
                    attrs: { to: link.route }
                  },
                  [_vm._v(_vm._s(link.title))]
                )
              ],
              1
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b978ac5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b978ac5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Breadcrumbs.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0b978ac5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Breadcrumbs.vue
// module chunks = 0 1 2